import {
  chainCommands,
  exitCode,
  joinDown,
  joinUp,
  lift,
  liftEmptyBlock,
  setBlockType,
  splitBlock,
  toggleMark,
} from 'prosemirror-commands'
import { redo, undo } from 'prosemirror-history'
import { undoInputRule } from 'prosemirror-inputrules'
import { Schema } from 'prosemirror-model'
import { liftListItem, sinkListItem, splitListItem, wrapInList } from 'prosemirror-schema-list'

/*
  Copied from prosemirror example docs.
  @see https://github.com/ProseMirror/prosemirror-example-setup/blob/master/src/keymap.ts
 */

export const mac = typeof navigator != 'undefined' ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false
export const commandKeySymbol = () => (mac ? '⌘' : 'Ctrl')
export const optionsKeySymbol = () => (mac ? '⌥' : 'Alt')

export const buildKeymap = (schema: Schema) => {
  const handleHardBreak = chainCommands(exitCode, (state, dispatch) => {
    if (dispatch) dispatch(state.tr.replaceSelectionWith(schema.nodes.hard_break.create()).scrollIntoView())
    return true
  })
  const map: Record<string, Function> = {
    'Mod-z': undo,
    'Shift-Mod-z': redo,
    Backspace: undoInputRule,
    'Alt-ArrowUp': joinUp,
    'Alt-ArrowDown': joinDown,
    'Mod-BracketLeft': lift,
    'Mod-b': toggleMark(schema.marks.strong),
    'Mod-B': toggleMark(schema.marks.strong),
    'Mod-i': toggleMark(schema.marks.em),
    'Mod-I': toggleMark(schema.marks.em),
    'Mod-u': toggleMark(schema.marks.underline),
    'Mod-U': toggleMark(schema.marks.underline),
    'Mod-`': toggleMark(schema.marks.code),
    'Mod-Shift-7': wrapInList(schema.nodes.ordered_list),
    'Mod-Shift-8': wrapInList(schema.nodes.bullet_list),
    'Mod-Enter': handleHardBreak,
    'Shift-Enter': chainCommands(liftEmptyBlock, splitListItem(schema.nodes.list_item), splitBlock),
    Enter: splitListItem(schema.nodes.list_item),
    'Mod-[': liftListItem(schema.nodes.list_item),
    'Mod-]': sinkListItem(schema.nodes.list_item),
    'Shift-Ctrl-\\': setBlockType(schema.nodes.code_block),
  }

  if (!mac) map['Mod-y'] = redo
  if (mac) map['Ctrl-Enter'] = handleHardBreak

  return map
}
